import React, {PureComponent} from "react"

import id from "@irati/utils/id"
import FormattedMessage from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"

import {StyledTooltip} from "../styled/styled"

interface Props {
  header: string,
  toolTipText: string
}

class TooltipHeader extends PureComponent<Props> {
  render() {
    const idNamespace = id("TeamsHeader", this.props)
    const {header, toolTipText} = this.props
    return (
      <Flex alignItems="center" id={idNamespace}>
        <FormattedMessage id={header} />
        <StyledTooltip tooltipChildren="testing" placement="top">
          <FormattedMessage id={toolTipText} />
        </StyledTooltip>
      </Flex>
    )
  }
}

export default TooltipHeader
